module.exports = __webpack_public_path__ + "img/login_left.88364b76.png";